import Vue from "vue";
import VueRouter from "vue-router";
import Layouts from "../layouts";
import Parent from "../layouts/components/AppContent"

Vue.use(VueRouter);

/**
 *  path: "/login",   ------页面地址
 meta: {
      title: "登录",    ------页面标题
      icon: "el-icon-user-solid",  ------菜单图标
      oneself: true,  ------是否在单独页面打开
      hide: true,  ------是否隐藏改菜单
    },
 component: () => import("../views/login/index.vue"),  ------组件地址
 */

const routes = [
    {
        path: "",
        redirect: "/homePage",
        component: Layouts,
        children: [
            {
                path: "/login",
                name: "Login",
                meta: {
                    title: "6C数据中心",
                    oneself: true,
                    hide: true,
                },
                component: () => import("../views/login"),
            },
            {
                path: "/homePage",
                meta: { title: "业务服务中心", icon: "el-icon-s-home" },
                component: () => import("../views/homePage"),

            },
            {
                path: "/user-service",
                meta: { title: "用户服务中心", icon: "el-icon-cpu" },
                component: Parent,
                children: [
                    {
                        path: "personnel",
                        meta: { title: "人员信息管理", icon: "el-icon-link" },
                        component: () => import("../views/user-service/personnel"),
                    },
                    {
                        path: "/userInfo",
                        name: "UserInfo",
                        meta: {
                            title: "用户中心",
                        },
                        component: () => import("../views/user-service/userInfo"),
                    },
                    {
                        path: "workshop",
                        meta: { title: "组织架构管理", icon: "el-icon-reading" },
                        component: () => import("../views/user-service/workshop"),
                    },
                    {
                        path: "dict",
                        meta: { title: "字典管理", icon: "el-icon-reading" },
                        component: () => import("../views/user-service/dict"),
                    },
                    {
                        path: "dict/data",
                        name: "dictData",
                        meta: { title: "字典数据", icon: "el-icon-discover", hide: true },
                        component: () => import("../views/user-service/dictData.vue"),
                    },
                ]
            },
            {
                path: "/permissions-service",
                meta: { title: "权限服务中心", icon: "el-icon-data-line" },
                component: Parent,
                children: [
                    {
                        path: "role",
                        meta: { title: "用户权限角色管理", icon: "el-icon-data-board" },
                        component: () => import("../views/permissions-service/role"),
                    },
                    {
                        path: "menu",
                        meta: { title: "功能菜单信息管理", icon: "el-icon-pie-chart" },
                        component: () => import("../views/permissions-service/menu"),
                    },

                ]
            },
            {
                path: "/data-service",
                meta: { title: "数据服务中心", icon: "el-icon-data-analysis" },
                component: Parent,
                children: [
                    {
                        path: "unit",
                        meta: { title: "部件管理", icon: "el-icon-collection-tag" },
                        component: () => import("../views/data-service/unit"),
                    },

                    {
                        path: "station",
                        meta: { title: "区站管理", icon: "el-icon-suitcase" },
                        component: () => import("../views/data-service/station"),

                    },
                    {
                        path: "defectGrade",
                        meta: { title: "缺陷等级管理", icon: "el-icon-suitcase-1" },
                        component: () => import("../views/data-service/defectGrade"),
                    },
                    {
                        path: "defectType",
                        meta: { title: "缺陷类型管理", icon: "el-icon-receiving" },
                        component: () => import("../views/data-service/defectType"),
                    },
                    {
                        path: "line",
                        meta: { title: "线路管理", icon: "el-icon-collection" },
                        component: () => import("../views/data-service/line"),
                    },
                    {
                        path: "pillar",
                        meta: { title: "支柱管理", icon: "el-icon-collection" },
                        component: () => import("../views/data-service/pillar"),
                    },
                    {
                        path: "pipeboundary",
                        meta: { title: "管界管理", icon: "el-icon-collection" },
                        component: () => import("../views/data-service/pipeboundary"),
                    },
                    {
                        path: "apparatus",
                        meta: { title: "装置管理", icon: "el-icon-files" },
                        component: () => import("../views/data-service/apparatus"),
                    },
                ]
            },
            {
                path: "/document-service",
                meta: { title: "文档服务中心", icon: "el-icon-table-lamp" },
                component: Parent,
                children: [
                    {
                        path: "video",
                        meta: { title: "视频库管理", icon: "el-icon-coin" },
                        component: () => import("../views/document-service/video"),
                    },
                    {
                        path: "picture",
                        meta: { title: "图片库管理", icon: "el-icon-wallet" },
                        component: () => import("../views/document-service/picture"),
                    },
                    {
                        path: "oscillogram",
                        meta: { title: "波形图管理", icon: "el-icon-tickets" },
                        component: () => import("../views/document-service/oscillogram"),
                    },
                ]
            },
            {
                path: "/logs-service",
                meta: { title: "日志服务中心", icon: "el-icon-set-up" },
                component: Parent,
                children: [
                    {
                        path: "login-logs",
                        meta: { title: "登录日志记录", icon: "el-icon-document" },
                        component: () => import("../views//logs-service/loginLogs"),
                    },
                    {
                        path: "controls-logs",
                        meta: { title: "操作日志记录", icon: "el-icon-discover" },
                        component: () => import("../views//logs-service/controlsLogs"),
                    },
                ]
            },
            // ===== 微前端子应用路由（path 与数据库 sys_menu 的菜单 path 一致，qiankun 按 activeRule 挂载）=====
            {
                path: "/1c",
                meta: { title: "1C系统", icon: "el-icon-s-data" },
                component: Parent,
            },
            {
                path: "/2c",
                meta: { title: "2C系统", icon: "el-icon-s-data" },
                component: Parent,
            },
            {
                path: "/3c",
                meta: { title: "3C系统", icon: "el-icon-s-data" },
                component: Parent,
            },
            {
                path: "/4c",
                meta: { title: "4C系统", icon: "el-icon-s-data" },
                component: Parent,
            },
            {
                path: "/5c",
                meta: { title: "5C系统", icon: "el-icon-s-data" },
                component: Parent,
            },
            {
                path: "/tunnel2c",
                meta: { title: "隧道2C", icon: "el-icon-s-data" },
                component: Parent,
            },
            {
                path: "/simple1c",
                meta: { title: "简易1C", icon: "el-icon-s-data" },
                component: Parent,
            },
            {
                path: "/simple4c",
                meta: { title: "简易4C", icon: "el-icon-s-data" },
                component: Parent,
            },
            {
                path: "/icing",
                meta: { title: "覆冰检测", icon: "el-icon-s-data" },
                component: Parent,
            },
        ],
    },
];

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法，取消路由重复的报错
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

// 前置路由拦截器
router.beforeEach((to, from, next) => {
    // 设置当前页签名称
    document.title = to.meta.title;
    // 没有登录并且要去的页面不是登录页面，在强制跳转到登录
    if (to.path === "/login") {
        localStorage.removeItem('access_token')
        next()
    } else if (!localStorage.getItem('access_token')) {
        next('/login')
    } else {
        next()
    }
});

export default router;
